import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";

import { formatISO } from "@/utils/date";

import { OrderDetailsComponent } from "./orderDetails.component";

type OrderDetailsProps = {
    orderDetails: OrderDetail;
};

const OrderDetails = ({ orderDetails }: OrderDetailsProps) => {
    const creationDate = formatISO(orderDetails.creationDate);

    return (
        <OrderDetailsComponent
            creationDate={creationDate}
            payments={orderDetails.payments}
        />
    );
};

export { OrderDetails };
